export function studioZoom(value:number):number{return Math.max(.5,Math.min(4,Number.isFinite(value)?value:1));}
/** Keep the same source point under the zoom anchor; view changes never edit pixels. */
export function studioZoomScroll(left:number,top:number,anchorX:number,anchorY:number,from:number,to:number){
  const ratio=studioZoom(to)/studioZoom(from);
  return {left:Math.max(0,(left+anchorX)*ratio-anchorX),top:Math.max(0,(top+anchorY)*ratio-anchorY)};
}
